import {
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";

export async function getAllSurveyQuestions() {
  const surveyRef = collection(db, "survey_questons");
  const surveySnapshot = await getDocs(surveyRef);

  const surveyQuestions = [];
  surveySnapshot.forEach((doc) => {
    let data = doc.data();
    data.id = doc.id;
    surveyQuestions.push(data);
  });
  console.log(surveyQuestions);
  return surveyQuestions;
}

export const getSurveyById = async (surveyAnswerId) => {
  try {
    const surveyAnswerRef = doc(db, "survey_answers", surveyAnswerId);

    const surveyAnswerSnapshot = await getDoc(surveyAnswerRef);

    if (surveyAnswerSnapshot.exists()) {
      const surveyData = {
        id: surveyAnswerSnapshot.id,
        ...surveyAnswerSnapshot.data(),
      };

      return surveyData;
    } else {
      throw new Error("Survey not found");
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const saveSurveyAnswers = async (surveyAnswerId, surveyAnswers) => {
  try {
    const surveyAnswerRef = doc(db, "survey_answers", surveyAnswerId);

    return updateDoc(surveyAnswerRef, {
      dateUpdated: new Date().toString(),
      answers: surveyAnswers,
    });
  } catch (error) {
    console.error("Error updating survey answers document:", error);
    throw new Error(error);
  }
};
